import { createPortal } from "react-dom";
import Div from "../Div"; 
import Form from "../Form";
import FormButton from "../FormButton";
import Input from "../Input";
import Select from "../Select";
// Removed unused useState import to fix warning
import { insertKAMMeetingHttp } from "../../http/renewalHttp/RenewalHttp"; 

export default function InsertMeetingModal({ customer_data, handleClicked, ...props }) {
    
    function handleClose() {
        handleClicked(false);
    }

    async function handleSubmit(event) {
        event.preventDefault();
        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData.entries());
        
        // Pass both IDs and Name from the row data
        data.domain_id = customer_data.domain_id; 
        data.domain_name = customer_data.customerDomain;

        // --- LOG DATA IN BROWSER CONSOLE ---
        console.log("---------- SENDING MEETING DATA ----------");
        console.log("Domain:", data.domain_name);
        console.log("Full Payload:", data);

        const response = await insertKAMMeetingHttp(data);
        if (response && !response.error) {
            alert("Meeting Details Saved Successfully");
            handleClose();
        } else {
            alert("Failed to save meeting details. Check backend console.");
        }
    }

    // Options mapping (Product list, meeting types, percentages)
    const meetingTypes = [
        { id: 'onsite', value: 'onsite' },
        { id: 'online', value: 'online' }
    ].map(item => <option key={item.id} value={item.id}>{item.value}</option>);

    const productOptions = [
        "Renewal Discussion","Renewal Expansion","New Domain", "Jumpcloud", "Scalefusion", "Checkpoint", 
        "Gemini Ultra", "Gemini Enterprise", "Okta", "Jamf", 
        "Wizz", "AWS", "GCP", "MiniOrange"
    ].map(prod => <option key={prod} value={prod}>{prod}</option>);

    const percentageOptions = ["100%", "75%", "50%", "25%"].map(pct => 
        <option key={pct} value={pct}>{pct}</option>
    );

    return createPortal(
        <Div className="modal-backdrop">
            <dialog open {...props} style={{ zIndex: '1', margin: 'auto', padding: '20px', width: '500px' }}>
                <Div className="modal-content">
                    <h5 className="mb-3">Insert Meeting: {customer_data.customerDomain}</h5>
                    <hr />
                    <Form onSubmit={handleSubmit}>
                        <Div className="form-group row">
                            <label className="col-sm-4">Meeting Type</label>
                            <Div className="col-sm-8">
                                <Select name="meeting_type" options={meetingTypes} defaultValue="" />
                            </Div>
                        </Div>

                        <Div className="form-group row">
                            <label className="col-sm-4">New Opps (Product)</label>
                            <Div className="col-sm-8">
                                <Select name="new_opps_product" options={productOptions} />
                            </Div>
                        </Div>

                        <Div className="form-group row">
                            <label className="col-sm-4">New Opps (Count)</label>
                            <Div className="col-sm-8">
                                <Input name="new_opps_count" type="number" placeholder="Count" />
                            </Div>
                        </Div>

                        <Div className="form-group row">
                            <label className="col-sm-4">Adoption</label>
                            <Div className="col-sm-8">
                                <Select name="adoption" options={percentageOptions} defaultValue="25%" />
                            </Div>
                        </Div>

                        <Div className="form-group row">
                            <label className="col-sm-4">Support Rating</label>
                            <Div className="col-sm-8">
                                <Select name="support_rating" options={percentageOptions} defaultValue="50%" />
                            </Div>
                        </Div>

                        <Div className="form-group row">
                            <label className="col-sm-4">Feedback</label>
                            <Div className="col-sm-8">
                                <textarea name="feedback" className="form-control" rows="2"></textarea>
                            </Div>
                        </Div>

                        <Div className="form-group row">
                            <label className="col-sm-4">Followup Date</label>
                            <Div className="col-sm-8">
                                <Input name="followup_date" type="date" />
                            </Div>
                        </Div>

                        <Div className="d-flex justify-content-end mt-3">
                            <FormButton type="submit" className="btn btn-primary mr-2">Save Meeting</FormButton>
                            <FormButton type="button" className="btn btn-secondary" onClick={handleClose}>Close</FormButton>
                        </Div>
                    </Form>
                </Div>
            </dialog>
        </Div>,
        document.getElementById('modal')
    );
}